import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from '../component/layouts/dashboard/dashboard.component';
import { AuthGuard } from '../shared/auth.guard';
import { PermissionGuard } from '../shared/permission.guard';
import { IntelligenceDashboardComponent } from './intelligence-dashboard/intelligence-dashboard.component';
import { IntelligenceRankingComponent } from './intelligence-ranking/intelligence-ranking.component';
import { IntelligenceHistoryComponent } from './intelligence-history/intelligence-history.component';
import { UnitMaintenanceHistoryComponent } from './unit-maintenance-history/unit-maintenance-history.component';

const routes: Routes = [{
    path: "unit/intelligence-center", component: DashboardComponent, canActivate: [AuthGuard, PermissionGuard], children: [{
        path: "", component: IntelligenceDashboardComponent, data: { module: "Unidad", accion: "Centro de inteligencia operativa", type: "intelligence-dashboard" }
    }, {
        path: "ranking/:groupBy", component: IntelligenceRankingComponent, data: { module: "Unidad", accion: "Centro de inteligencia operativa / Ranking completo", type: "view" }
    }, {
        path: "history/:groupBy/:id", component: IntelligenceHistoryComponent, data: { module: "Unidad", accion: "Centro de inteligencia operativa / Historial operativo", type: "view" }
    }]
}, {
    path: "unit/maintenance-history", component: DashboardComponent, canActivate: [AuthGuard], children: [{
        path: ":id", component: UnitMaintenanceHistoryComponent, data: { module: "Unidad", accion: "Histórico de mantenimiento", type: "view" }
    }]
}];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UnitIntelligenceRoutingModule { }
